import * as Yup from "yup";

export const inventoryTargetSettingsBranchValidationRules = () =>
  Yup.object().shape({
    // branchCode: Yup.string()
    //   .nullable()
    //   .required("Please provide Branch Code for this setup"),
    month: Yup.number()
      .nullable()
      .min(0)
      .required("Please provide month for this setup"),
    year: Yup.number()
      .nullable()
      .min(0)
      .required("Please provide year for this setup"),
    targetPiece: Yup.number("Please enter a valid number")
      .min(0)
      .required("Please provide value for this setup"),
    targetPrincipal: Yup.number("Please enter a valid number")
      .min(0)
      .required("Please provide value for this setup"),
  });

export default inventoryTargetSettingsBranchValidationRules;
